import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import { generatedBillJSON } from "../../DynamicFormsJson/MastersJSON/generatedBill";
import {
  getGenratedBillListByDateNew,
  getGenratedBillListByDate,
  setGenratedBillList,
} from "../../Slice/orderBillList.slice";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicMainScreen";
import endpoint from "../../config/endpoints";
import {
  cancelBillMsg,
  generateBillMsg,
  noInternetMsg,
  savemsg,
  serverMsg,
} from "../../config/messageconstant";
import { apiGet, apiPost } from "../../utils/api_service";

// import { getStockStackHolders } from "../../Slice/StackHolder.slice";
import { Grid, Paper } from "@mui/material";
import { GeneratedBillListColumns } from "../../tableColumns/table-columns";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { downloadF } from "../PDF/PDFDownload";
import EWayPopUp from "./EWayPopUp";
import CheckBoxSelectionTable from "../../components/Comman/RT/CheckBoxSelectionTable";
import { withRouter } from "../../components/withRouter";
import { compose } from "@reduxjs/toolkit";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { ButtonCompo } from "../../components/Comman/Button";

const columns = [
  {
    title: "Sr. No.",
    name: "index",
    positionCenter: true,
    align: "center",

  },
  {
    title: "Bill No",
    name: "billNo",
    positionCenter: true,
    canSearch: true,
    align: "center",
  },
  {
    title: "Bill Date",
    name: "billDate",
    positionCenter: true,
    canSearch: true,
    align: "center",
  },
  {
    title: "Firm Name",
    name: "ownerAndFirmName",
    positionCenter: false,
    canSearch: true,
    align: "left",
  },
  {
    title: "State Name",
    name: "toBillStateName",
    positionCenter: false,
    canSearch: true,
    align: "left",
  },
  {
    title: "Area Name",
    name: "toBillAreaNames",
    positionCenter: false,
    canSearch: true,
    align: "left",
  },
  {
    title: "Taxable Amount",
    name: "taxableAmt",
    positionCenter: false,
    canSearch: true,
    alignCenter: "right",
  },
  {
    title: "CGST",
    name: "cgstAmt",
    positionCenter: false,
    canSearch: true,
    alignCenter: "right",
  },
  {
    title: "SGST",
    name: "sgstAmt",
    positionCenter: false,
    canSearch: true,
    alignCenter: "right",
  },
  {
    title: "IGST",
    name: "igstAmt",
    positionCenter: false,
    canSearch: true,
    alignCenter: "right",
  },

  {
    title: "Total Amount",
    name: "totalAmt",
    positionCenter: false,
    canSearch: true,
    alignCenter: "right",
  },
  {
    title: "Bill Received",
    name: "isRecievedName",
    positionCenter: true,
    canSearch: true,
    align: "center"
  },
  {
    title: "Status",
    name: "statusForColumn",
    positionCenter: true,
    canSearch: true,
    align: "center"
  },
  { name: "action", title: "Action", align: "center" },
];
class ListOfGeneratedBill extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDate: "",
      toDate: "",
      popUpFlag: false,
      popUpData: {},
      statusFlag: false,
      showFilterDataWiseExcel: "",
      selection: [],
      dynamicMasterData: {
        stakeholdersDetail: this.props.stakeholdersList.stockStakeHolders,
      },
    };
  }
  async componentDidMount() {
    const { setGenratedBillList, showLoador, showNotification } = this.props;

    const showFilterDataWiseExcel = localStorage.getItem(
      "showFilterDataWiseExcel"
    );
    this.setState({ showFilterDataWiseExcel });

    setGenratedBillList({ row: [] });

    this.getData();
  }

  getData = async () => {
    const {
      getGenratedBillListByDateNew,
      getGenratedBillListByDate,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {
      let status = "";

      await this.setState({ fromDate: "", toDate: "" });

      const userTypeId = localStorage.getItem("userTypeId");

      const noOfDays = localStorage.getItem("daysForPrimaryOrderOnLoad");

      const isCallGeneratedBillsByDateApi = localStorage.getItem("isCallGeneratedBillsByDateApi");

      let fromDateWithDaysValidation = dayjs()
        .subtract(noOfDays && noOfDays !== null ? noOfDays : 7, "day")
        .format("DD-MM-YYYY");

      if (isCallGeneratedBillsByDateApi == 1) {
        showLoador({ loador: true });
        await getGenratedBillListByDate({
          fromDate: dayjs().format("DD-MM-YYYY"),
          toDate: dayjs().format("DD-MM-YYYY"),
        }).then(({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            if (response.length !== 0) {
              if (response.length !== 0) {
                response.map((obj) => {
                  if (obj.status === 1) {
                    this.setState({
                      statusFlag: true,
                    });
                  }
                });
              }
            }
          }
        });
      } else {
        showLoador({ loador: true });
        await getGenratedBillListByDateNew({
          fromDate: fromDateWithDaysValidation,
          toDate: dayjs().format("DD-MM-YYYY"),
        }).then(({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            if (response.length !== 0) {
              if (response.length !== 0) {
                response.map((obj) => {
                  if (obj.status === 1) {
                    this.setState({
                      statusFlag: true,
                    });
                  }
                });
              }
            }
          }
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.stakeholdersList !== nextProps.stakeholdersList) {
      if (
        this.props.stakeholdersList?.stockStakeHolders !==
        nextProps.stakeholdersList?.stockStakeHolders
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stakeholdersDetail: nextProps.stakeholdersList?.stockStakeHolders,
          },
        });
      }
    }
  }

  handleCloses = () => {
    this.setState({
      popUpFlag: false,
    });
  };

  onSearchList = async (data) => {
    const {
      getGenratedBillListByDateNew,
      getGenratedBillListByDate,
      showLoador,
      showNotification,
    } = this.props;
    let status = "";
    if (navigator.onLine) {

      const isCallGeneratedBillsByDateApi = localStorage.getItem("isCallGeneratedBillsByDateApi");

      if (isCallGeneratedBillsByDateApi == 1) {
        showLoador({ loador: true });
        await getGenratedBillListByDate({
          fromDate: data.fromDate,
          toDate: data.toDate,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            if (response.length !== 0) {
              response.map((obj) => {
                if (obj.status === 1) {
                  this.setState({
                    statusFlag: true,
                  });
                }
              });
            }
          }

          this.setState({
            fromDate: data.fromDate ? data.fromDate : "",
            toDate: data.toDate ? data.toDate : "",
          });
        });
      } else {
        showLoador({ loador: true });
        await getGenratedBillListByDateNew({
          fromDate: data.fromDate,
          toDate: data.toDate,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            if (response.length !== 0) {
              response.map((obj) => {
                if (obj.status === 1) {
                  this.setState({
                    statusFlag: true,
                  });
                }
              });
            }
          }

          this.setState({
            fromDate: data.fromDate ? data.fromDate : "",
            toDate: data.toDate ? data.toDate : "",
          });
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };
  rowPDF = (rowData) => {
    const { lang } = this.state;
    const { showLoador, showNotification } = this.props;
    localStorage.setItem("lang", lang);
    const showPdfType = localStorage.getItem("showPdf");

    if (showPdfType == 0) {
      localStorage.setItem("myBillPdfID", rowData.id);
      window.open("./my-bill-pdf", "_blank");
    }
    if (showPdfType == 1) {
      localStorage.setItem("myNewBillPdfID", rowData.id);
      window.open("./new-my-bill-pdf", "_blank");
    }
    if (showPdfType == 2) {
      //   if (navigator.onLine) {

      //     showLoador({ loador: true });
      //     apiGet({
      //         url:
      //             endpoint.stockStakeholderBillHeader +
      //             "/report-by-ids?ids=" +
      //             rowData.id +
      //             "&languageId=" + lang,
      //     }).then(({ data, success }) => {
      //         showLoador({ loador: false });
      //         if (!success) {
      //             showNotification({
      //                 msg: serverMsg,
      //                 severity: "error",
      //             });
      //         } else {
      //             console.log(data.data);
      //              if(data.data.length!=0){
      //               this.generatePDFHeader(data.data)

      //              }

      //         }
      //     });
      // } else {
      //     showNotification({ msg: noInternetMsg, severity: "error" });
      // }
      localStorage.setItem("myBillPdfID", rowData.id);
      window.open("./my-bill-pdf", "_blank");
    }
  };

  generateExcel = (rowData) => {
    const { fromDate, toDate } = this.state;
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {

      const noOfDays = localStorage.getItem("daysForPrimaryOrderOnLoad");

      const fromDateDefault = dayjs()
        .subtract(noOfDays && noOfDays !== null ? noOfDays : 7, "day")
        .format("DD-MM-YYYY");

      const toDateDefault = dayjs().format("DD-MM-YYYY");

      const fromDateToSend = fromDate || fromDateDefault;
      const toDateToSend = toDate || toDateDefault;

      showLoador({ loador: true });
      downloadF({
        url:
          endpoint.stockStakeholderBillHeader +
          "/generated-bills-excel-by-date?fromDate=" +
          fromDateToSend +
          "&toDate=" +
          toDateToSend,
        ext: "xls",
        openNewTab: true,
      }).then(({ response, success }) => {
        showLoador({ loador: false });
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onClickApply = (rowData) => {
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      let detailList = rowData.stockStakeHolderBillDetails.map((dataObj) => {
        return {
          ...dataObj,
          product: { id: dataObj.productId },
        };
      });

      let dataJson = {
        ...rowData,
        stockStakeHolderBillDetails: detailList,
      };

      swal({
        title: "Are you sure?",
        text: generateBillMsg,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          showLoador({ loador: true });
          apiPost({
            url: endpoint.eInvoice,
            postBody: dataJson,
          }).then(({ data, success }) => {
            console.log(data);
            showLoador({ loador: false });
            if (!success) {
              this.props.showNotification({
                msg: serverMsg,
                severity: "error",
              });
            } else {
              if (data.data.message) {
                this.props.showNotification({ msg: data.data.message });
              } else {
                this.props.showNotification({ msg: savemsg });
              }
            }
          });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onClickEWay = (rowData) => {
    const { showLoador, showNotification } = this.props;
    this.setState({
      popUpFlag: true,
      popUpData: rowData,
    });
  };

  getSelectedList = (e) => {
    const { generatedBillList } = this.props;
    this.setState({
      selection: e,
    });
    const rowList = generatedBillList.genratedBillNew.map((rowData) => {
      const filterData = e.filter((id) => rowData.id == id);
      return { ...rowData, checked: filterData.length != 0 ? true : false };
    });
  };

  onClickCancel = (rowData) => {
    const { showLoador, showNotification } = this.props;
    swal({
      title: "Are you sure?",
      text: cancelBillMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        showLoador({ loador: true });
        apiGet({
          url:
            endpoint.stockStakeholderBillHeader +
            "/update-status?status=1&id=" +
            rowData.id,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
            this.props.showNotification({
              msg: serverMsg,
              severity: "error",
            });
          } else {
            this.props.showNotification({ msg: savemsg });
          }
        });
      }
    });
  };

  rowView = (rowData) => {
    this.props.navigate(generatedBillJSON.formPathView + "/" + rowData.id);
  };

  generateExcelNew = () => {
    const { showLoador, showNotification } = this.props;
    const { selection } = this.state;

    if (selection.length == 0) {
      this.props.showNotification({
        msg: "Please select at least one bill before exporting",
        severity: "error",
      });
      return;
    }

    const dataToSave = {
      billIds: selection,
    };

    if (navigator.onLine) {
      showLoador({ loador: true });
      downloadF({
        isGet: false,
        url: endpoint.exportData + "/stock-stack-holder-bill-export-excel",
        postBody: dataToSave,
        ext: "xls",
        openNewTab: true,
      }).then((response) => {
        showLoador({ loador: false });
        if (!response) {
          this.props.showNotification({
            msg: serverMsg,
            severity: "error",
          });
        } else {
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  render() {
    const { generatedBillList, setGenratedBillList } = this.props;
    const {
      dynamicMasterData,
      popUpFlag,
      popUpData,
      statusFlag,
      showFilterDataWiseExcel,
      selection,
    } = this.state;

    const isShowApplyAtGenetateBill = localStorage.getItem("isShowApplyAtGenetateBill");

    const isShowEwayAtGenerateBill = localStorage.getItem("isShowEwayAtGenerateBill");

    const isShowCancelAtGenerateBill = localStorage.getItem("isShowCancelAtGenerateBill");

    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 0,
          }}
          elevation={0}
        >
          <DynamicMainScreen
            showViewButtonInTable={true}
            showDeleteIcon={false}
            dynamicMasterData={dynamicMasterData}
            searchList={generatedBillJSON.searchList}
            onSearchData={this.onSearchList}
            formPathView={generatedBillJSON.formPathView}
            formPath={generatedBillJSON.formPath}
            screenTitle={generatedBillJSON.screenTitle}
            fieldMeta={generatedBillJSON.fieldMeta}
            showPdfDownload={false}
            showExcelDownload={false}
            filterDataExcel={showFilterDataWiseExcel == 1 ? true : false}
            staticExcel={showFilterDataWiseExcel == 1 ? false : true}
            generateExcelStatic={this.generateExcelStatic}
            isActiveURL={generatedBillJSON.isActiveURL}
            showAddButton={false}
            tableColumnsToFilter={generatedBillJSON.tableColumnsToFilter}
            // tableColumns={GeneratedBillListColumns}
            tableData={generatedBillList.genratedBillNew}
            getTableData={this.getData}
            apiBaseURL={generatedBillJSON.apiBaseURL}
            callApi={false}
            getTableDataById={true}
            showSearchBox={false}
            rowPDF={this.rowPDF}
            showPdf={true}
            deleteURL={generatedBillJSON.deleteURL}
            deleteURLStatic={true}
            showPegination={false}
            // showSearch={false}
            showApply={isShowApplyAtGenetateBill == 1 ? true : false}
            credentialConditionName="showGeneratedInvoice"
            credentialConditionValue="0"
            showApplyTitle={"Generate Invoice"}
            rowApply={this.onClickApply}
            showEWay={isShowEwayAtGenerateBill == 1 ? true : false}
            showEWayTitle={"E-Way Bill"}
            rowEWay={this.onClickEWay}
            showCancel={isShowCancelAtGenerateBill == 1 ? true : false}
            cancelBillConditionName="isRecievedName"
            cancelBillConditionValue="No"
            rowCancel={this.onClickCancel}
            editConditionName="isRecieved"
            editConditionValue="0"
            showEditIcon={false}
          />
          <LandingScreenHeader
            screenTitle={""}
            showTable={true}
            showSearchBox={false}
            showBackButton={false}
            showAddButton={false}
            showPdfDownload={false}
            showExcelDownload={showFilterDataWiseExcel == 1 ? true : false}
            generateExcel={this.generateExcel}
          />
          <CheckBoxSelectionTable
            selection={selection}
            onSelectionChange={this.getSelectedList}
            disabled={true}
            rows={generatedBillList.genratedBillNew}
            columns={columns}
            showDetailsIcon={true}
            showViewButtonInTable={true}
            rowView={this.rowView}
            isActionColActive={true}
            rowApply={this.onClickApply}
            showApply={isShowApplyAtGenetateBill == 1 ? true : false}
            showApplyTitle={"Generate Invoice"}
            credentialConditionName="showGeneratedInvoice"
            credentialConditionValue="0"
            rowPrint={this.rowPDF}
            SummarizeRoundedShow={true}
            showEWay={isShowEwayAtGenerateBill == 1 ? true : false}
            rowEWay={this.onClickEWay}
            showCancel={isShowCancelAtGenerateBill == 1 ? true : false}
            rowCancel={this.onClickCancel}
            cancelBillConditionName="isRecievedName"
            cancelBillConditionValue="No"

          // rowAppliedList={this.rowAppliedList}
          // isActionColActive={true}
          // onSelectionChange={this.getRow}
          />
          <Grid
            item
            sm={12}
            xs={12}
            md={4}
            lg={4}
            sx={{ marginTop: 3, display: "flex", justifyContent: "flex-end" }}
          >
            <ButtonCompo
              size="medium"
              type="submit"
              variant="contained"
              name="Export"
              fullWidth={false}
              onClick={this.generateExcelNew}
            />
          </Grid>
          {popUpFlag && (
            <>
              <EWayPopUp
                open={popUpFlag}
                handleCloses={this.handleCloses}
                popUpData={popUpData}
                onSave={this.saveHandler}
              />
            </>
          )}
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  stakeholdersList: state.stackholder,
  generatedBillList: state.billHeaderList,
});
const mapDispatchToProps = {
  showNotification,
  showLoador,
  getGenratedBillListByDateNew,
  getGenratedBillListByDate,
  setGenratedBillList,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ListOfGeneratedBill);
